const initialState = {
  next: 1,
  previous: null,
};

export default function paginationReducer(state = initialState, action) {
  const { pagination } = action;
  if (pagination) {
    return {
      ...state,
      ...pagination,
    };
  } else {
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/paginationReducer.js